import { FC, useContext, useState } from "react"
import Text from "lib/components/Text"
import { LanguageContext } from "context/LanguageContext"
import Icons from "lib/components/Icons"

interface FaqListItem {
  title: string
  children: string
  id: string
}

const BusinessFaqs: FC = () => {
  const { useTranslation: t } = useContext(LanguageContext)
  const [openFaq, setOpenFaq] = useState(null)

  const faqData = t("faq_data_business")
  const faqListItem: Array<FaqListItem> = Array.isArray(faqData) ? faqData : []

  const toggleAccordion = (id: string) => {
    setOpenFaq(openFaq === id ? null : id)
  }

  return (
    <section className="container mx-auto px-4 md:px-8 lg:px-0 py-8 lg:py-[52px] flex flex-col gap-6 lg:gap-8">
      <div className="w-full flex items-center justify-center">
        <Text weight="semibold" customClass="text-center text-base lg:text-2xl">
          FAQS
        </Text>
      </div>
      <div className="w-full flex flex-col gap-3 lg:gap-5">
        {faqListItem.map((item) => (
          <button
            key={item.id}
            type="button"
            className="w-full border border-neutral-40 rounded-lg px-4 py-2 flex flex-col gap-1"
            onClick={() => toggleAccordion(item.id)}>
            <div className="w-full flex flex-row items-center justify-between lg:h-10">
              <Text weight="medium" customClass="flex items-center text-xs lg:text-base">
                {item.title}
              </Text>
              <div className="flex items-center">
                <Icons
                  iconName="expand-more"
                  styles={
                    openFaq === item.id
                      ? "transform rotate-180 duration-300"
                      : "transform rotate-0 duration-300"
                  }
                  width="24px"
                  color="black"
                />
              </div>
            </div>
            <div className={`${openFaq === item.id ? "flex" : "hidden"} w-full flex-col gap-1`}>
              <hr className="bg-neutral-40 h-px w-full" />
              <p
                className="text-start text-xs lg:text-sm"
                dangerouslySetInnerHTML={{ __html: item.children }}
              />
            </div>
          </button>
        ))}
      </div>
    </section>
  )
}

export default BusinessFaqs
